module.exports = __webpack_public_path__ + "static/media/hp_Prev.a8f5c516.svg";